const siteList = () => import('@/pages/site/index.vue');
const siteForm = () => import('@/pages/site/form.vue');

export default [{
    path: '/site/list',
    component: siteList,
    meta: [{
        name: '站点管理'
    },
    {
        name: '站点列表',
        activeRoute: '/site/list'
    }]
},
{
	path: '/site/form',
	component: siteForm,
	meta: [{
        name: '产品管理'
    },
    {
        name: '产品列表',
        url: '/site/list'
    },
    {
        name: '新增/编辑',
        activeRoute: '/site/list'
    }]
}
];